import styled from 'styled-components'

import { zIndexRegistry } from '@/constants/zIndexRegistry'
import { TextLink } from '@/ui/atoms/text-link'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

type SrpSortContainerProps = {
  buttonColor: string
}

export const SrpSortContainer = styled.div<SrpSortContainerProps>(
  ({ theme, buttonColor }) => `


  position: relative;
  z-index: ${zIndexRegistry.SRP_SORT_DROPDOWN};

  & button {
    color: ${buttonColor};
  }

  ${MEDIA_QUERIES(theme).medium} {
    height: 4.8rem;
    margin-top: 0;
  }
`
)

export const MobileSortTextLinkButton = styled(TextLink).attrs(() => ({ as: 'button' }))(
  ({ theme }) => `
    display: flex;
    font-weight: ${theme.fontWeight.medium};
    gap: ${theme.spacing.mini};
  `
)
